import Tilt from "react-tilty";
import { useRef, useEffect, useState } from "react";
import { motion, useScroll } from "framer-motion";

const githubUrl1 = "https://moviebird.netlify.app/";
const githubUrl2 = "https://manage-school.netlify.app/";
const githubUrl3 = "https://github.com/mananc12/Secrets";
const githubUrl4 = "https://github.com/mananc12/911";

const ExternalLink = ({ url, children }) => {
  const handleClick = () => {
    window.open(url, "_blank");
  };

  return (
    <div onClick={handleClick} style={{ cursor: "pointer" }}>
      {children}
    </div>
  );
};

export default function FifthSection() {
  const ref = useRef(null);
  const { scrollXProgress } = useScroll({ container: ref });

  const [isTiltEnabled, setTiltEnabled] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 901) {
        setTiltEnabled(false);
      } else {
        setTiltEnabled(true);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="fifthSection">
      <span className="grey special-sub-heading">Showcasing expertise</span>
      <h1 className="special-main-heading">Projects</h1>
      <div className="text-card-container">
        <div className="text-box">
          <p>
            Take a closer look at each project to explore its features,
            technologies utilized, and the problems it aims to solve. I hope
            these projects give you a glimpse of my skills, creativity, and
            dedication to delivering exceptional results. Feel free to reach out
            to me for more information or collaboration opportunities!
          </p>
        </div>
        <div className="card-progress-container">
          <svg id="progress" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="42" pathLength="1" className="bg" />
            <motion.circle
              cx="50"
              cy="50"
              r="42"
              pathLength="1"
              className="indicator"
              style={{ pathLength: scrollXProgress }}
            />
          </svg>
          <ul className="all-project-cards" ref={ref}>
            {isTiltEnabled ? (
              <>
                <li>
                  <div className="card">
                    <ExternalLink className="link" url={githubUrl1}>
                      <Tilt className="project" options={{ scale: 1.05, max: 30 }}>
                        <div className="project-image">
                          <img src="images/movie.png" alt="Project 1" />
                        </div>
                        <div className="project-details">
                          <h3>Movie🐦Bird</h3>
                          <p>Search for unlimited movies by title and conveniently bookmark them.</p>
                        </div>
                      </Tilt>
                    </ExternalLink>
                  </div>
                </li>
                <li>
                  <div className="card ">
                    <ExternalLink className="link" url={githubUrl2}>
                      <Tilt className="project" options={{ scale: 1.05, max: 30 }}>
                        <div className="project-image">
                          <img src="images/xyz.png" alt="Project 2" />
                        </div>
                        <div className="project-details">
                          <h3>School Management Template</h3>
                          <p>Designed for managing various aspects of a school.</p>
                        </div>
                      </Tilt>
                    </ExternalLink>
                  </div>
                </li>
                <li>
                  <div className="card">
                    <ExternalLink className="link" url={githubUrl3}>
                      <Tilt className="project" options={{ scale: 1.05, max: 30 }}>
                        <div className="project-image">
                          <img src="images/secrets.jpg" alt="Project 3" />
                        </div>
                        <div className="project-details">
                          <h3>Secrets</h3>
                          <p>
                            Allow users to anonymously share their secrets. It provides user authentication and security features.
                          </p>
                        </div>
                      </Tilt>
                    </ExternalLink>
                  </div>
                </li>
                <li>
                  <div className="card ">
                    <ExternalLink className="link" url={githubUrl4}>
                      <Tilt className="project" options={{ scale: 1.05, max: 30 }}>
                        <div className="project-image">
                          <img src="images/emergency.jpg" alt="Project 4" />
                        </div>
                        <div className="project-details">
                          <h3>Medical Facilities Web Application</h3>
                          <p>Search for nearby hospitals and medical facilities.</p>
                        </div>
                      </Tilt>
                    </ExternalLink>
                  </div>
                </li>
              </>
            ) : (
              <>
                <li>
                  <div className="card">
                    <ExternalLink className="link" url={githubUrl1}>
                      <div className="project">
                        <div className="project-image">
                          <img src="images/movie.png" alt="Project 1" />
                        </div>
                        <div className="project-details">
                          <h3>Movie🐦Bird</h3>
                          <p>Search for unlimited movies by title and conveniently bookmark them.</p>
                        </div>
                      </div>
                    </ExternalLink>
                  </div>
                </li>
                <li>
                  <div className="card ">
                    <ExternalLink className="link" url={githubUrl2}>
                      <div className="project">
                        <div className="project-image">
                          <img src="images/xyz.png" alt="Project 2" />
                        </div>
                        <div className="project-details">
                          <h3>School Management Template</h3>
                          <p>Designed for managing various aspects of a school.</p>
                        </div>
                      </div>
                    </ExternalLink>
                  </div>
                </li>
                <li>
                  <div className="card">
                    <ExternalLink className="link" url={githubUrl3}>
                      <div className="project">
                        <div className="project-image">
                          <img src="images/secrets.jpg" alt="Project 3" />
                        </div>
                        <div className="project-details">
                          <h3>Secrets</h3>
                          <p>
                            Allow users to anonymously share their secrets. It provides user authentication and security features.
                          </p>
                        </div>
                      </div>
                    </ExternalLink>
                  </div>
                </li>
                <li>
                  <div className="card ">
                    <ExternalLink className="link" url={githubUrl4}>
                      <div className="project">
                        <div className="project-image">
                          <img src="images/emergency.jpg" alt="Project 4" />
                        </div>
                        <div className="project-details">
                          <h3>Medical Facilities Web Application</h3>
                          <p>Search for nearby hospitals and medical facilities.</p>
                        </div>
                      </div>
                    </ExternalLink>
                  </div>
                </li>
              </>
            )}
          </ul>
          <div className="threeD-image">
            <img src="images/3d-img.png" alt="3d-pic" />
          </div>
        </div>
      </div>
    </div>
  );
}
